import {Injectable} from '@angular/core'

@Injectable()
export class AnimationService {

    animationItem: any = []

}
